import {mergeLeft, equals} from 'ramda';
import * as actions from './actions';
import * as selectors from './selectors';
import {catchNonFatalDefault} from 'io/errors';
import {getBuildings, getBuilding, createVisit} from './io';
import {effect} from 'utils/redux';
import namespace from './namespace';
import {decorateWithNotifications} from 'io/app';
import {getQuery, pushQuery} from 'io/history';
import {parseUrlQuery} from './utils';
import services from 'services';
import {createReferrerUrl, encodeQuery} from 'utils/url';

const creator = effect(namespace);

const history = services.get('history');

let intl = null;
services.waitFor('intl').then(x => (intl = x));

const fetchBuildings = (getState, dispatch) => {
	return decorateWithNotifications(
		{id: 'fetch-buildings', failureStyle: 'error'},
		getBuildings(selectors.buildingsQueryFetchable(getState())),
	)(getState, dispatch).then(buildings => {
		dispatch(actions._setBuildings(buildings));
	});
};

const fetchBuilding = buildingId => (getState, dispatch) => {
	return decorateWithNotifications(
		{id: 'fetch-building', failureStyle: 'warning'},
		getBuilding(buildingId),
	)(getState, dispatch).then(building => {
		dispatch(actions._updateBuilding(building));
	});
};

export let initialize = () => (getState, dispatch) => {
	const {buildingsQuery} = parseUrlQuery(getQuery());
	const {dismissPrompt} = buildingsQuery;

	if (dismissPrompt) {
		dispatch(actions._updateBuildingsQuery(buildingsQuery));
		fetchBuildings(getState, dispatch).catch(catchNonFatalDefault(getState, dispatch));
	}
};
initialize = creator('initialize', initialize);

export let updateBuildings = () => (getState, dispatch) => {
	pushQuery(mergeLeft(selectors.urlQuery(getState())));
	fetchBuildings(getState, dispatch).catch(catchNonFatalDefault(getState, dispatch));
};
updateBuildings = creator('updateBuildings', updateBuildings);

export let recheckQuery = () => (getState, dispatch) => {
	const urlQueries = parseUrlQuery(getQuery());
	const buildingsQuery = selectors.buildingsQuery(getState());
	if (!equals(buildingsQuery, urlQueries.buildingsQuery)) {
		dispatch(actions._updateBuildingsQuery(urlQueries.buildingsQuery));
		fetchBuildings(getState, dispatch).catch(catchNonFatalDefault(getState, dispatch));
	}
};

export let notReached = buildingId => (getState, dispatch) => {
	decorateWithNotifications(
		{
			id: 'not-reached',
			failureStyle: 'error',
			loading: intl.formatMessage({id: 'Saving visit'}),
			success: intl.formatMessage({id: 'Visit saved'}),
		},
		createVisit({
			appointment: false,
			reached: false,
			buildingId,
		}),
	)(getState, dispatch)
		.catch(e => {
			dispatch(actions._opFailed());
			throw e;
		})
		.then(() => {
			dispatch(actions._opOk());
			return fetchBuilding(buildingId)(getState, dispatch);
		})
		.catch(catchNonFatalDefault(getState, dispatch));
};
notReached = creator('notReached', notReached);

export let updateBuilding = bid => (getState, dispatch) => {
	fetchBuilding(bid)(getState, dispatch).catch(catchNonFatalDefault(getState, dispatch));
};
updateBuilding = creator('updateBuilding', updateBuilding);

export let navigateToBuilding = bid => (getState, dispatch) => {
	const referrerUrl = createReferrerUrl(history.location);
	history.push(
		`/d2d/listview/buildings/${bid}${encodeQuery({
			referrer: 'listview',
			referrerUrl,
		})}`,
	);
};
navigateToBuilding = creator('navigateToBuildings', navigateToBuilding);
